import { z } from 'zod';
import type { VomPartsFragment } from '~/apollo/generated/v4/graphql';
import { ppArrayOrNull, ppNumberOrNull, ppStringOrNull } from '~/utils/zod';

export const vomSchema = z.object({
  name: z.string().min(1),
  projectId: z.preprocess(ppNumberOrNull, z.number().int().positive()),
  outcropId: z.preprocess(ppNumberOrNull, z.number().int().positive()),
  size: z.string().min(1),
  smallestVisibleFeature: z.string().min(1),
  approved: z.boolean(),
  quality: z.preprocess(ppStringOrNull, z.string().nullable()),
  notableAspects: z.preprocess(ppStringOrNull, z.string().nullable()),
  acquisitionYear: z.preprocess(ppNumberOrNull, z.number().int().positive()),
  aquiringPerson: z.string().min(1),
  acquisitionType: z.string().min(1),
  acquisitionEquipment: z.string().min(1),
  processingYear: z.preprocess(ppNumberOrNull, z.number().int().positive()),
  processingPerson: z.string().min(1),
  copyright: z.preprocess(ppArrayOrNull, z.array(z.string().min(1)).min(1)),
  copyrightLogo: z.preprocess(ppArrayOrNull, z.array(z.string()).nullable()),
  comments: z.preprocess(ppStringOrNull, z.string().nullable()),
  v3GeoId: z.preprocess(ppNumberOrNull, z.number().int().positive().nullable()),
});

export type VomFormValues = {
  name: string;
  projectId: string;
  outcropId: number | null;
  size: string;
  smallestVisibleFeature: string;
  approved: boolean;
  quality: string;
  notableAspects: string;
  acquisitionYear: string;
  aquiringPerson: string;
  acquisitionType: string;
  acquisitionEquipment: string;
  processingYear: string;
  processingPerson: string;
  copyright: string[];
  copyrightLogo: string[];
  comments: string;
  v3GeoId: string;
};

export function initialVom(vom?: VomPartsFragment): VomFormValues {
  return {
    name: vom?.name ?? '',
    projectId: String(vom?.projectId ?? ''),
    outcropId: vom?.outcropId ?? null,
    size: vom?.size ?? '',
    smallestVisibleFeature: vom?.smallestVisibleFeature ?? '',
    approved: vom?.approved ?? false,
    quality: vom?.quality ?? '',
    notableAspects: vom?.notableAspects ?? '',
    acquisitionYear: String(vom?.acquisitionYear ?? ''),
    aquiringPerson: vom?.aquiringPerson ?? '',
    acquisitionType: vom?.acquisitionType ?? '',
    acquisitionEquipment: vom?.acquisitionEquipment ?? '',
    processingYear: String(vom?.processingYear ?? ''),
    processingPerson: vom?.processingPerson ?? '',
    copyright: vom?.copyright ?? [],
    copyrightLogo: vom?.copyrightLogo ?? [],
    comments: vom?.comments ?? '',
    v3GeoId: String(vom?.v3GeoId ?? ''),
  };
}
